import React, { FC, useState } from 'react';
import { SCUIButton, SCUILoadingLinear } from '../../atomic/atoms';
import { SCUIContent } from '../../atomic/organisms';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { SCUIBreadCrumb } from '../../atomic/molecules';
import { TextField, Stack } from '@mui/material';
import RetailCommand from '../../services/command/retail/retailCommand.services';
import { RDB } from './retailDb.classes';

export const RetailDb: FC<any> = () => {
    const { t } = useTranslation();
    const [salesId, setSalesId] = useState('');
    const [warehouse, setWarehouse] = useState('');
    const [loading, setLoading] = React.useState(false);

    const returnValue = () => {
        if (salesId.trim().length === 0 && warehouse.trim().length === 0)
            Swal.fire(t('retail.salesIdAndWarehouseCanNotbeNull'), ' ', 'error');
        else if (salesId.trim().length === 0) Swal.fire(t('retail.salesIdCanNotbeNull'), ' ', 'error');
        else if (warehouse.trim().length === 0) Swal.fire(t('retail.warehouseCanNotbeNull'), ' ', 'error');
        setLoading(false);
    };

    const deleteFromTransferTable = async () => {
        let params: any = [];
        setLoading(true);
        Swal.fire({
            text: t('general.sureText'),
            cancelButtonText: t('general.cancel'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('general.delete'),
        }).then((result: any) => {
            if (result.isConfirmed) {
                salesId
                    .trim()
                    .split('\n')
                    .forEach((item: any) => {
                        let tempObj: any = {};
                        tempObj.SaleId = item;
                        tempObj.Warehouse = warehouse;
                        params.push(tempObj);
                    });
                if (salesId && warehouse && warehouse.trim().length > 0) {
                    RetailCommand.PostDeleteTransferTableRetailById(params)
                        .then(() => {
                            Swal.fire(t('general.deleted'), ' ', 'success');
                            setLoading(false);
                        })
                        .catch((error: any) => {
                            Swal.fire('', ' ', 'error');
                            console.log('Hata :>> ', error);
                        });
                } else {
                    returnValue();
                }
            } else {
                setLoading(false);
            }
        });
    };

    const deleteFromMainTable = async () => {
        let params: any = [];
        setLoading(true);
        Swal.fire({
            text: t('general.sureText'),
            cancelButtonText: t('general.cancel'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('general.delete'),
        }).then((result: any) => {
            if (result.isConfirmed) {
                salesId
                    .trim()
                    .split('\n')
                    .forEach((item: any) => {
                        let tempObj: any = {};
                        tempObj.SaleId = item;
                        tempObj.Warehouse = warehouse;
                        params.push(tempObj);
                    });
                if (salesId && warehouse && warehouse.trim().length > 0) {
                    RetailCommand.PostDeleteMainTableRetailById(params)
                        .then(() => {
                            Swal.fire(t('general.deleted'), ' ', 'success');
                            setLoading(false);
                        })
                        .catch((error: any) => {
                            Swal.fire('', ' ', 'error');
                            console.log('Hata :>> ', error);
                        });
                } else {
                    returnValue();
                }
            } else {
                setLoading(false);
            }
        });
    };

    return (
        <SCUIContent className={RDB.page}>
            <div className={RDB.loadingSection}>
                <SCUILoadingLinear display={loading} />
            </div>
            <div className={RDB.breadcrumbSection}>
                <SCUIBreadCrumb title={t('dashboard.retail')} componentLink={'RetailDb'} />
            </div>

            <Stack className={RDB.formStack} direction={'column'}>
                <TextField
                    className={RDB.inputSalesId}
                    label={t('retail.salesId')}
                    value={salesId}
                    multiline
                    rows={10}
                    onChange={(event: any) => {
                        setSalesId(event.target.value);
                    }}
                    slotProps={{ inputLabel: { shrink: true } }}
                    sx={{ marginBottom: 1, width: 450 }}
                />
                <TextField
                    className={RDB.inputWarehouse}
                    style={{ width: '450px' }}
                    placeholder={t('retail.warehouse')}
                    onChange={(event: any) => {
                        setWarehouse(event.target.value);
                    }}
                />
            </Stack>
            <div
                className={RDB.actionsRow}
                style={{
                    display: 'flex',
                    marginTop: '1rem',
                    justifyContent: 'space-between',
                    width: '450px',
                    padding: '2rem',
                }}
            >
                <SCUIButton
                    className={RDB.deleteFromTransferButton}
                    text={t('retail.deleteFromTransferTable')}
                    type="primary"
                    sizeType="fixed"
                    size={'m'}
                    style={{ flex: 1, marginRight: '1rem' }}
                    onClick={() => {
                        deleteFromTransferTable();
                    }}
                />
                <SCUIButton
                    className={RDB.deleteFromMainButton}
                    text={t('retail.deleteFromMainTable')}
                    type="primary"
                    sizeType="fixed"
                    size={'m'}
                    style={{ flex: 1 }}
                    onClick={() => {
                        deleteFromMainTable();
                    }}
                />
            </div>
        </SCUIContent>
    );
};
